import React, {useState} from 'react';
import { useHistory } from "react-router-dom";
import { postNodo } from '../routing/routes';

const NuevoNodo = ({nodos,refreshData,setNotification}) => {
    const history = useHistory();
    const [nuevoNodo,nuevoNodoChanged] = useState({nodo:'', nombre:'', aristas: [], nodoInicial: undefined, nodoFinal: undefined})
    const nodoValidation = nodos.find(nodo => nodo.nodo === nuevoNodo.nodo) !== undefined
    const nombreValidation = nuevoNodo.nombre.length === 0
    function create(){
        postNodo(nuevoNodo)
        .then((res) => {
            refreshData()
            history.push("/edit/"+res.insertedId)
            setNotification("mNodo creado correctamente!")
        })
        .catch(error => {
            setNotification("eOcurrió un error creando el nodo!");
            console.error('Error:', error)
        })
    }

    return(
        <div style={{width:'80%',margin:'40px auto'}}>
            <div align="right">
                <div className='taby'>
                Nuevo Nodo
                </div>
            </div>
            <div className='form-container'>
                <div className='form-row'>
                    <div>
                        <label>Número</label><br/>
                        { nodoValidation && 
                            <>
                                <small style={{color:'red'}}>Número ocupado, favor de usar otro</small>
                            <br/></>
                        }
                        <input type="number" onChange={(e)=>nuevoNodoChanged({...nuevoNodo, nodo: Number(e.target.value)})}
                            value={nuevoNodo.nodo}>
                        </input>
                    </div>
                    <div>
                        <label>Nombre</label><br/>
                        <input onChange={(e)=>nuevoNodoChanged({...nuevoNodo, nombre: e.target.value})}
                            value={nuevoNodo.nombre}
                        ></input>
                    </div>
                </div>
                <div style={{padding:'20px 0 -0 80px', marginBottom:'-40px' }}>
                        <button className={'nodo-button ' + (nuevoNodo.nodoInicial && 'nodo-button-green')} onClick={()=>nuevoNodoChanged({...nuevoNodo, nodoInicial: true, nodoFinal: undefined})}>Inicial</button>
                        <button className={'nodo-button ' + (!nuevoNodo.nodoInicial && !nuevoNodo.nodoFinal && 'nodo-button-normal')} onClick={()=>nuevoNodoChanged({...nuevoNodo, nodoInicial: undefined, nodoFinal: undefined})}>Normal</button>
                        <button className={'nodo-button ' + (nuevoNodo.nodoFinal && 'nodo-button-red')} onClick={()=>nuevoNodoChanged({...nuevoNodo, nodoInicial: undefined, nodoFinal: true})}>Final</button>
                </div>
                <div className='form-actions' align="right">
                    <button className='form-button secondary-button'
                        onClick={()=>history.push("/")}
                    >Cancelar</button>
                    <button disabled={nodoValidation || nombreValidation}
                        onClick={()=>create()} className='form-button primary-button'
                    >Guardar</button>
                </div>

            </div>
        </div>
    )
}

export default NuevoNodo;